<template>
  <div class="widgetContainer">
    <Card
      v-if="simulations"
      class="widget"
    >
      <div class="cardContainer">
        <div class="widgetHeader">
          <VideoIcon class="icon" />
          <HeadingSmall>
            {{ title }}
          </HeadingSmall>
        </div>
      </div>
      <ParagraphBody class="widgetSubheader">
        View guided simulations
      </ParagraphBody>
      <HomeWidgetCarousel
        v-if="simulations.length"
        :cardComponent="carouselCard"
        :items="simulations"
        @simulation-clicked="handleSimulationClicked"
      />
    </Card>
  </div>
</template>

<script>
import {
  Card, HeadingSmall, ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventProperties, itemTypePages } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { simulations } from 'client/util/Constants/SimulationConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetCarousel from 'client/Discover/components/HomeWidgetCarousel.vue';
import SimulationCard from 'client/Discover/components/SimulationCard';
import VideoIcon from 'public/img/growth/video-neutral.svg?inline';

const { location } = eventProperties;

export default {
  name: 'SimulationWidget',

  components: {
    Card,
    HeadingSmall,
    HomeWidgetCarousel,
    ParagraphBody,
    VideoIcon,
  },

  EventHelper,

  props: {
    itemType: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    carouselCard: SimulationCard,
    title: 'Tutorial Resources',
  }),

  computed: {
    simulations() {
      return simulations[this.itemType];
    },
  },

  methods: {
    handleSimulationClicked(eventData) {
      this.$options.EventHelper.triggerModalViewed({
        ...eventData,
        [location]: itemTypePages[this.itemType],
      });
    },
  },
};
</script>

<style scoped>
.widgetContainer {
  margin-bottom: var(--jc-spacer);
}

.cardContainer {
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--jc-spacer-x-small);
}

.widgetHeader {
  display: flex;
  flex-direction: row;
}

.icon {
  height: var(--jcHeadingMedium);
  margin-right: var(--jc-spacer-small);
  width: var(--jcHeadingMedium);
}

.widgetSubheader {
  display: inline-block;
  text-align: left;
  vertical-align: top;
  width: 45%;
}

.widget.widget {
  padding-bottom: 0;
}
</style>
